module.exports = __webpack_public_path__ + "img/EE4128_FC8E82_9A0704_BF0F05-256px.27828dd0.png";